import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`By building dykes that allow for controlled flooding and irrigation, WFP also helped strengthen people’s resilience to climate shocks. These families can now grow their own food while not having to be afraid that heavy rains or floods will wash away or damage their crops.`}</p>
    <p>{`WFP and its partners also worked to improve the access to highly nutritious food for children under five by supporting the local production of `}<a parentName="p" {...{
        "href": "https://twitter.com/WFP_Europe/status/1205883656834813963"
      }}>{`fortified instant flour`}</a>{`. Set up with the help of the EU, the first fortified food was produced in Chad in 2019 and was a major step forward in the country’s fight against malnutrition.`}</p>
    <p>{`In parallel, investments in the government’s capacity to enhance food security and nutrition are crucial to reduce the country’s humanitarian needs in the future. That’s why WFP has been helping the government with technical support and staff trainings with the aim of improving the mapping and analysis of the nation’s nutrition situation. With support from the EU, WFP has also provided research and advice that will help create sound national policies and strategies to boost food security across the country.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      